module.exports = "<svg id=\"177b350d-1551-4c7e-8e12-2bc4ab3180f0\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>nav-smile-gallery</title><polygon points=\"25 40.28 9.89 48.21 12.82 31.43 0.58 19.54 17.47 17.07 25 1.79 32.53 17.07 49.42 19.54 37.18 31.43 40.11 48.21 25 40.28\" style=\"fill:#fff\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/nav-smile-gallery.svg
// module id = 557
// module chunks = 1